export const DEFAULT_TEMA = 'friskis'
export default {
  appelsinsorbet: {
    backgroundFrom: '#FFE3B3',
    backgroundTo: '#FFB27B',
    pattern: '#fff',
    primary: '#612703',
    secondary: '#A96338',
    navBackground: '#fff',
    navForeground: '#784323 ',
    navActiveBackground: '#C67645',
    navActiveForeground: '#fff',
    linkText: '#29272a',
    linkBackdrop: 'rgba(255, 255, 255, 0.3)',
    interactionCta: '#C67645',
    logoBase: '#C67645',
    logoFrom: '#EA9C6B',
    logoTo: 'rgba(211, 132, 82, 0.6)',
    logoDot: '#EA9C6B',
  },
  pistasj: {
    backgroundFrom: '#E4FDE1',
    backgroundTo: '#6BA292',
    pattern: '#fff',
    primary: '#263B34',
    secondary: '#435F55',
    navBackground: '#fff',
    navForeground: '#3C584E',
    navActiveBackground: '#4B695E',
    navActiveForeground: '#fff',
    linkText: '#29272a',
    linkBackdrop: 'rgba(255, 255, 255, 0.3)',
    interactionCta: '#4B695E',
    logoBase: '#4B695E',
    logoFrom: '#6BA992',
    logoTo: 'rgba(77, 125, 107, 0.6)',
    logoDot: '#6BA992',
  },
  friskis: {
    backgroundFrom: '#FEE5CE',
    backgroundTo: '#E28B8B',
    pattern: '#fff',
    primary: '#492C2C',
    secondary: '#AC4F4F',
    navBackground: '#fff',
    navForeground: '#724040',
    navActiveBackground: '#D66565',
    navActiveForeground: '#fff',
    linkText: '#29272a',
    linkBackdrop: 'rgba(255, 255, 255, 0.3)',
    interactionCta: '#D66565',
    logoBase: '#D66565',
    logoFrom: '#FC9696',
    logoTo: 'rgba(228, 128, 128, 0.6)',
    logoDot: '#FC9696',
  },
  kraesjpink: {
    backgroundFrom: '#E8B7D4',
    backgroundTo: '#BFB8DA',
    pattern: '#fff',
    primary: '#243A4F',
    secondary: '#435D76',
    navBackground: '#fff',
    navForeground: '#324960',
    navActiveBackground: '#527392',
    navActiveForeground: '#fff',
    linkText: '#29272a',
    linkBackdrop: 'rgba(255, 255, 255, 0.3)',
    interactionCta: '#527392',
    logoBase: '#527392',
    logoFrom: '#83A2C0',
    logoTo: 'rgba(116, 148, 179, 0.6)',
    logoDot: '#83A2C0',
  },
  blaafruktfest: {
    backgroundFrom: '#D6E8EE',
    backgroundTo: '#8392DE',
    pattern: '#fff',
    primary: '#222844',
    secondary: '#424762',
    navBackground: '#fff',
    navForeground: '#313A62',
    navActiveBackground: '#4F5675',
    navActiveForeground: '#fff',
    linkText: '#29272a',
    linkBackdrop: 'rgba(255, 255, 255, 0.3)',
    interactionCta: '#4F5675',
    logoBase: '#4F5675',
    logoFrom: '#7983B2',
    logoTo: 'rgba(103, 113, 158, 0.6)',
    logoDot: '#7983B2',
  },
  vannmelon: {
    backgroundFrom: '#C7F7D2',
    backgroundTo: '#F888A3',
    pattern: '#fff',
    primary: '#48232C',
    secondary: '#7D3E4C',
    navBackground: '#fff',
    navForeground: '#6C2233',
    navActiveBackground: '#B25A6E',
    navActiveForeground: '#fff',
    linkText: '#29272a',
    linkBackdrop: 'rgba(255, 255, 255, 0.3)',
    interactionCta: '#B25A6E',
    logoBase: '#B25A6E',
    logoFrom: '#E393A6',
    logoTo: 'rgba(201, 116, 136, 0.6)',
    logoDot: '#E393A6',
  },
  mint: {
    backgroundFrom: '#BEE2CD',
    backgroundTo: '#6C966B',
    pattern: '#fff',
    primary: '#162516',
    secondary: '#2E472D',
    navBackground: '#fff',
    navForeground: '#2D442C',
    navActiveBackground: '#365435',
    navActiveForeground: '#fff',
    linkText: '#29272a',
    linkBackdrop: 'rgba(255, 255, 255, 0.3)',
    interactionCta: '#365435',
    logoBase: '#365435',
    logoFrom: '#588856',
    logoTo: 'rgba(79, 123, 78, 0.6)',
    logoDot: '#588856',
  },
  lakris: {
    backgroundFrom: '#FFE0BB',
    backgroundTo: '#8A73CA',
    pattern: '#fff',
    primary: '#1A1626',
    secondary: '#554B71',
    navBackground: '#fff',
    navForeground: '#3C3551',
    navActiveBackground: '#5E537D',
    navActiveForeground: '#fff',
    linkText: '#29272a',
    linkBackdrop: 'rgba(255, 255, 255, 0.3)',
    interactionCta: '#5E537D',
    logoBase: '#5E537D',
    logoFrom: '#987BC1',
    logoTo: 'rgba(111, 90, 170, 0.6)',
    logoDot: '#987BC1',
  },
  tuttifrutti: {
    backgroundFrom: '#FFDFC8',
    backgroundTo: '#FF9567',
    pattern: '#fff',
    primary: '#3D1809',
    secondary: '#9C4722',
    navBackground: '#fff',
    navForeground: '#541F09',
    navActiveBackground: '#A7461D',
    navActiveForeground: '#fff',
    linkText: '#29272a',
    linkBackdrop: 'rgba(255, 255, 255, 0.3)',
    interactionCta: '#A7461D',
    logoBase: '#B85329',
    logoFrom: '#EC8960',
    logoTo: 'rgba(218, 119, 78, 0.6)',
    logoDot: '#EC8960',
  },
  bringebaersorbet: {
    backgroundFrom: '#FFEAE5',
    backgroundTo: '#FFACAC',
    pattern: '#fff',
    primary: '#38141F',
    secondary: '#812F47',
    navBackground: '#fff',
    navForeground: '#511A2B',
    navActiveBackground: '#AF4263',
    navActiveForeground: '#fff',
    linkText: '#29272a',
    linkBackdrop: 'rgba(255, 255, 255, 0.3)',
    interactionCta: '#AF4263',
    logoBase: '#AF4263',
    logoFrom: '#EF8DAB',
    logoTo: 'rgba(228, 112, 147, 0.6)',
    logoDot: '#EF8DAB',
  },
  lavendel: {
    backgroundFrom: '#C3B5FF',
    backgroundTo: '#70E3BA',
    pattern: '#fff',
    primary: '#12312C',
    secondary: '#1E5047',
    navBackground: '#fff',
    navForeground: '#19413A',
    navActiveBackground: '#296C61',
    navActiveForeground: '#fff',
    linkText: '#29272a',
    linkBackdrop: 'rgba(255, 255, 255, 0.3)',
    interactionCta: '#296C61',
    logoBase: '#296C61',
    logoFrom: '#54A194',
    logoTo: 'rgba(75, 151, 139, 0.6)',
    logoDot: '#54A194',
  },
}
